import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import * as tenantActions from '../tenantInfo/tenant.actions';
import { push } from 'react-router-redux';

export function requireTenant(Component, opts = {}) {
  class TenantComponent extends React.Component {

    componentWillMount() {
      this.getTenantInformation(this.props);
    }

    getTenantInformation(props) {
      const { tenant, tenantActions } = props;
      const { isFetching, currentTenant, err } = tenant;
      const slug = location.host;

      if (err) {
        return;  // do nothing here
      }

      if(currentTenant == null && !isFetching) {
         return tenantActions.getCurrentTenantFromSlug(slug);
      }
    }

    loadingMessage(message, isError) {
      var loadingState = {
        isLoading: !isError,
        error: isError ? {
          alertLevel: 'error',
          errorCode: 'error',
          errorMessage: message,
        } : null
      }

      return (
        <div className={'ssg-forms-session-loader'}>
          <div className="ssg-forms-session-loader-message">
            <LoadingPane id="session-loader" loadingState={loadingState} loadingMessage={message}/>
          </div>
        </div>
      )
    }

    render() {
      const { tenant } = this.props;
      const { err, isValid } = tenant;


      if ( !isValid ) {
        return this.loadingMessage('Loading customer data...');
      }

      if ( err ) {
        return this.loadingMessage('Could not find tenant', err);
      }

      return <Component {...this.props} />;
    }
  }

  TenantComponent.propTypes = {
    login: PropTypes.any,
    tenantActions: PropTypes.any.isRequired,
    routing: PropTypes.any.isRequired,
    opts: PropTypes.any.isRequired
  }

  function mapStateToProps({ tenant, routing, login }) {
    return {
      tenant,
      routing,
      login,
      opts
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      tenantActions: bindActionCreators(tenantActions, dispatch),
      redirect: bindActionCreators(push, dispatch)
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(TenantComponent)
}



// WEBPACK FOOTER //
// src/tenantInfo/require-tenant.js